<template>
    <div>
        <div class="row h-300">
            <div class="col-xl-5 p-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left px-xl-0 px-4">
                    {{ $t($route.meta.title) }}
                    <hr class="hr-title-mobile">
                </div>
            </div>

            <div class="col-xl-5 p-0">
                <div v-if="currentslick" class="h1 text-red labgrotesque-bold text-left px-xl-0 px-4 page-title">
                    <hr class="hr-title">
                    <span v-html="currentslick.title"></span>
                </div>

                <div class="description px-4 px-xl-0 d-none d-xl-block" v-if="currentslick" v-html="currentslick.body"></div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-10 offset-xl-1 col-12">
                <div :id="idslickcarousel" v-if="technologies.length > 0">
                    <div v-for="technology in technologies">
                        <div class="item">
                            <h4 class="content text-white labgrotesque-bold text-center w-75">{{ technology.title }}</h4>
                        </div>

                        <div class="img d-none">
                            <img class="imf-fluid" :src="technology.field_tecnologia_immagine">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row d-xl-none">
            <div class="col-12 p-0">
                <div class="description px-4 px-xl-0" v-if="currentslick" v-html="currentslick.body"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "technologies",

    data() {
        return {
            idslickcarousel: 'technologies-carousel',
            technologies: [],
            currentslick: null
        }
    },

    created() {
        axios.get(this.$route.meta.api + "/" + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            this.technologies = response.data;

            this.$nextTick(function() {
                this.initSlickCarousel();
            });
        });
    },

    methods: {
        initSlickCarousel() {
            var thisObj = this;
            var id = this.idslickcarousel;

            var slidetoshow = 7;
            if(this.technologies.length == 6 || this.technologies.length == 5) {
                slidetoshow = 5;
            }
            else if(this.technologies.length == 4 || this.technologies.length == 3) {
                slidetoshow = 3;
            }
            else if(this.technologies.length == 2 || this.technologies.length == 1) {
                slidetoshow = 1;
            }
            $('#' + id).slick({
                slidesToShow: slidetoshow,
                dots: false,
                centerMode: true,
                arrows: false,
                responsive: [
                {
                    breakpoint: 1251,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1921,
                    settings: {
                        slidesToShow: slidetoshow >= 3 ? 3 : 1,
                    }
                }]
            })
            .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                $('#' + id + ' div.slick-slide').addClass("nocurrent-slide");
                $('#' + id + ' [data-slick-index="' + nextSlide + '"]').removeClass("nocurrent-slide");
            })
            .on('afterChange', function(event, slick, currentSlide) {
                thisObj.$root.animejs({
                    targets: '#' + id + ' div.nocurrent-slide div.img',
                    opacity: 0,
                    easing: 'easeInOutQuad',
                    duration: 250,
                    begin: function(anim) {
                        $('#' + id + ' div.nocurrent-slide div.img').addClass("d-none");
                        $('#' + id + ' div.nocurrent-slide div.item').removeClass("d-none");
                    }
                });
                thisObj.$root.animejs({
                    targets: '#' + id + ' div.nocurrent-slide div.item',
                    opacity: 1,
                    easing: 'easeInOutQuad',
                    duration: 250
                });

                thisObj.$root.animejs({
                    targets: '#' + id + ' div.slick-current div.item',
                    opacity: 0,
                    easing: 'easeInOutQuad',
                    duration: 250
                });

                thisObj.$root.animejs({
                    targets: '#' + id + ' div.slick-current div.img',
                    opacity: [0, 1],
                    easing: 'easeInOutQuad',
                    duration: 250,
                    begin: function(anim) {
                        $('#' + id + ' div.slick-current div.item').addClass("d-none");
                        $('#' + id + ' div.slick-current div.img').removeClass("d-none");
                    }
                });

                thisObj.$root.animejs.timeline({loop: false})
                .add({
                    targets: '#' + id + ' div.slick-current div.img',
                    scale: 0.9,
                    duration: 250,
                    easing: 'linear'
                })
                .add({
                    targets: '#' + id + ' div.slick-current div.img',
                    scale: 1,
                    duration: 250,
                    easing: 'linear'
                })
                .add({
                    targets: '#' + id + ' div.slick-current div.img',
                    scale: 0.9,
                    duration: 250,
                    easing: 'linear'
                })
                .add({
                    targets: '#' + id + ' div.slick-current div.img',
                    scale: 1,
                    duration: 250,
                    easing: 'linear'
                });

                thisObj.currentslick = thisObj.technologies[currentSlide];
            });

            $('#' + id).slick("refresh");

            $("#" + id + " .slick-slide .item").on("click", function() {
                var index = $(this).parent().attr("data-slick-index");
                $('#' + id).slick("slickGoTo", index);
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/technology.vue